import { ActivatedRoute } from '@angular/router';
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { BaseOlsControlDirective } from '@components/public_api';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-external-redirect',
  templateUrl: './external-redirect.component.html',
  styleUrls: ['./external-redirect.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExternalRedirectComponent extends BaseOlsControlDirective implements OnInit {
  constructor(private route: ActivatedRoute) { super(); }

  title: string;
  url: string;

  ngOnInit(): void {
    if (!this.route) {
      return;
    }

    this.route.data.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.title = data['externalUrlTitle'];
      this.url = data['externalUrl'];

      if (!this.title || !this.url) {
        this.route.params.subscribe((params) => {
          if (!this.title) {
            this.title = params['externalUrlTitle'];
          }

          if (!this.url) {
            this.url = params['externalUrl'];
          }
        });
      }
    });

    setTimeout(() => {
      window.location.href = this.url;
    }, 3000);
  }

  getTitle(): string {
    if (this.title) {
      return this.title;
    }

    return this.url;
  }
}
